import * as _ from 'lodash';

export const filterId = 'unescape';
export const factory = () => input => _.unescape(input);